import {
  BlobToUint8,
  FromUnixTime,
  MapAsync,
  ResponseContentLength,
  ResponseHeader,
  StreamCreate,
  StreamToIterable,
  ToBlob,
  UnixTime,
} from "@pdfking/tfunc"

import type { CacheBackend } from "../types/CacheBackend"
import type { FileBound } from "../types/FileInfo"

const to_key = (file_id: string) => `https://cache/${file_id}`

export const FileCache = (cacheName: string): CacheBackend<FileBound> => ({
  async get(key: string): Promise<FileBound | undefined> {
    const c = await caches.open(cacheName)
    const response = await c.match(to_key(key))
    if (!response || !response.body) return undefined

    const header = ResponseHeader(response, "last-modified")
    const modified = UnixTime(header ? new Date(header) : undefined)

    return {
      stream: MapAsync(b => ToBlob(b), StreamToIterable(response.body)),
      size: ResponseContentLength(response),
      modified,
    }
  },
  async set(key: string, { stream, size, modified }: FileBound): Promise<void> {
    const c = await caches.open(cacheName)
    await c.put(
      to_key(key),
      new Response(StreamCreate(MapAsync(BlobToUint8, stream)), {
        headers: {
          "content-length": size.toString(),
          "last-modified": FromUnixTime(modified).toISOString(),
        },
      })
    )
  },
  async delete(key: string): Promise<void> {
    const c = await caches.open(cacheName)
    await c.delete(to_key(key))
  },
  async clear(): Promise<void> {
    await caches.delete(cacheName)
  },
  async exists(key: string): Promise<boolean> {
    const c = await caches.open(cacheName)
    const match = await c.match(to_key(key))
    return match !== undefined
  },
})
